import React, { useEffect, useRef, useState } from "react";
import "./styles.css";
import { OrdersTable } from "../../Components/Organisms";
import { Button, Spinner } from "@chakra-ui/react";
import { AddIcon } from "../../Assets/images/svgs";
import { useNavigate, useSearchParams } from "react-router-dom";
import PATHS from "../../Routes/paths";
import { LastOrder } from "../../Widgets";
import { getShipmentDetails } from "../../APIs";

const ShipmentOverview = () => {
  const navigate = useNavigate();
  const [ searchParams ] = useSearchParams();
  const SHIP_ID = useRef(searchParams.get("shipId"));

  const [ shipmentData, setShipmentData ] = useState({});

  useEffect(() => {
    getShipmentDetails(SHIP_ID.current || null, null, null, (err, data) => {
      if (err) console.error(err);
      else setShipmentData(data);
    })
  }, [])

  return (
    <section className="panel-main shipment-overview">
      <header className="shipment-overview-header">
        <Button onClick={() => navigate(PATHS.SHIPPING_DETAILS)} className="place-new-order-btn">
          <AddIcon className="new-order-icon" />
          Request Shipment
        </Button>
      </header>
      <div className="last-order shipment">
        {shipmentData.orders && shipmentData.orders.length ? <LastOrder shipmentData={shipmentData} title={"Recent Shipment Status"} isShipmentTimeLine={true} isShipmentOverviewPage={true}/> : null}
      </div>
      {shipmentData.orders && shipmentData.orders.length ? <OrdersTable shipmentData={shipmentData} title={"All Shipments"} shipment={true} /> : null}
    </section>
  )
}

export default ShipmentOverview
